<div class="container-fluid">
  <div class="card col-md-12">
    <div>
      <div class="card-body">
        @if (outstandingSignupFee) {
          <div class="card">
            <div class="card-header">
              <h2 class="orange-border">Sign-Up Fee</h2>
            </div>
            <div class="row prepaid-view  ml-1">
              <span class="my-auto">{{ outstandingSignupFee?.description }}</span>
              <span class="my-auto">{{ outstandingSignupFee?.amount | toMajor | currency:'R' }}</span>
              <span [ngClass]="getAccountStatusUtil().getAccountTextColorClass(outstandingSignupFee?.accountState)"
                class="my-auto">
                {{ outstandingSignupFee?.accountState | getAccountStatusDescription }}
              </span>
              <a [hidden]="!accountStatusUtil.isPaymentOutstanding(outstandingSignupFee?.accountState)"
                [href]="outstandingSignupFee?.qrCode"
                target="_blank">
                <button class="orange-btn btn-margin-top-bottom" style="width: 150px">
                  Pay Now&nbsp;
                </button>
              </a>
            </div>
          </div>
        }
        @if (outstandingSubscriptionFee) {
          <div class="card">
            <div class="card-header">
              <h2 class="orange-border">Subscription Fee</h2>
            </div>
            <div class="row ml-1">
              @if (outstandingSubscriptionFee) {
                <div class="prepaid-view">
                  <span class="my-auto">
                    {{ outstandingSubscriptionFee?.description }}
                    - {{ outstandingSubscriptionFee?.dateTimeCreated | date: 'MMMM' }}
                  </span>
                  <span class="my-auto">
                    {{ outstandingSubscriptionFee?.amount | toMajor | currency:'R' }}
                  </span>
                  <span [ngClass]="getAccountStatusUtil().getAccountTextColorClass(outstandingSubscriptionFee?.accountState)"
                    class="my-auto">
                    {{ outstandingSubscriptionFee?.accountState | getAccountStatusDescription }}
                  </span>
                  <a [hidden]="!accountStatusUtil.isPaymentOutstanding(outstandingSubscriptionFee?.accountState)"
                    [href]="outstandingSubscriptionFee?.qrCode"
                    target="_blank">
                    <button class="orange-btn btn-margin-top-bottom" style="width: 150px">
                      Pay Now&nbsp;
                    </button>
                  </a>
                </div>
              }
              @if (!outstandingSubscriptionFee) {
                <div class="pb-2">
                  No outstanding subscription fee
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    @if (messageBundles?.length > 0) {
      <div class="card-body">
        <div class="card">
          <div class="card-header">
            <h2 class="orange-border">Message Bundles</h2>
          </div>
        </div>
        <div>
          <p-divider align="left" class="mb-0">
            <div class="inline-flex align-items-center">
              <b>SMSs ({{ messageCounters?.smsCounter }} remaining)</b>
            </div>
          </p-divider>
          @if (smsBundles?.length === 0) {
            <p> No sms bundles to display</p>
          }
          <div class="row m-0">
            @for (smsBundle of smsBundles; track smsBundle) {
              <div class="p-card card py-4 bundle-card m-2">
                <div class="card-header p-0 m-0">
                  <h3 class="p-0 m-0" style="font-size: 1.75rem !important;">
                  {{ smsBundle.name }} </h3>
                </div>
                <div class="card-body flex-column align-content-around">
                  <p class=" py-3 m-0">
                    <b>{{ smsBundle.price | toMajor | currency:'R ' }}</b> <small> (incl. VAT)</small>
                    <br>{{ smsBundle.quantity }} sms </p>
                    <div [pTooltip]="getMessageBundleToolTip(hasOpenSmsBundleAccount, 'sms')">
                      <button (click)="confirmBuyBundleDialog(smsBundle)"
                        [disabled]="hasOpenSmsBundleAccount || isGuestAdminUser() || !isSubscriptionValid || hasSystemError"
                        class="navy-btn btn-margin-top-bottom">
                        Buy&nbsp; <i class="fa fa-cart-arrow-down fa-lg"></i>
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div>
            <p-divider align="left" class="mb-0">
              <div class="inline-flex align-items-center">
                <b>Emails ({{ messageCounters?.emailCounter }} remaining)</b>
              </div>
            </p-divider>
            @if (emailsBundles?.length === 0) {
              <p> No email bundles to display</p>
            }
            <div class="row m-0">
              @for (emailBundle of emailsBundles; track emailBundle) {
                <div class="p-card card py-4 bundle-card m-2">
                  <div class="card-header p-0 m-0">
                    <h3 class="p-0 m-0" style="font-size: 1.75rem !important;">
                    {{ emailBundle.name }} </h3>
                  </div>
                  <div class="card-body flex-column align-content-around">
                    <p class=" py-3 m-0">
                      <b>{{ emailBundle.price | toMajor | currency:'R ' }}</b> <small> (incl. VAT)</small>
                      <br>{{ emailBundle.quantity }} emails </p>
                      <div [pTooltip]="getMessageBundleToolTip(hasOpenEmailBundleAccount, 'email')">
                        <button (click)="confirmBuyBundleDialog(emailBundle)"
                          [disabled]="hasOpenEmailBundleAccount || isGuestAdminUser() || !isSubscriptionValid || hasSystemError"
                          class="navy-btn btn-margin-top-bottom">
                          Buy&nbsp; <i class="fa fa-cart-arrow-down fa-lg"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (lastPurchasedMessageBundles) {
          <div class="card-body my-3">
            <div class="card">
              <div class="card-header">
                <h2 class="orange-border">Previously Purchased Message Bundles</h2>
              </div>
            </div>
            <div>
              <p-divider align="left" class="mb-0">
                <div class="inline-flex align-items-center">
                  <b>SMSs</b>
                </div>
              </p-divider>
              @if (lastPurchasedSmsBundles?.length === 0) {
                <p>
                No previously purchased sms bundles to display.</p>
              }
              @if (lastPurchasedSmsBundles?.length !== 0) {
                <div>
                  <table class="table table-responsive-md">
                    <thead>
                      <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Date Bought</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody class="text-nowrap">
                      @for (messageBundleAccount of lastPurchasedSmsBundles; track messageBundleAccount) {
                        <tr>
                          <td>{{ messageBundleAccount.description }}</td>
                          <td>
                            <div [hidden]="messageBundleAccount.dateTimePaid === null">
                              {{ messageBundleAccount.dateTimePaid | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                            </div>
                          </td>
                          <td>{{ messageBundleAccount.amount | toMajor | currency:'R ' }}</td>
                          <td [ngClass]="getAccountStatusUtil().getAccountTextColorClass(messageBundleAccount.accountState)">
                            {{ getDisplayStatus(messageBundleAccount.accountState) }}
                          </td>
                          <td>
                            <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(messageBundleAccount.accountState)">
                              <button (click)="cancelMessageBundle(messageBundleAccount)" class="orange-btn">
                                Cancel
                              </button>
                            </div>
                          </td>
                          <td>
                            <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(messageBundleAccount.accountState)">
                              <button (click)="showQrCodeDialog(messageBundleAccount)" class="navy-btn">
                                Pay
                              </button>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
            <div>
              <p-divider align="left" class="mb-0">
                <div class="inline-flex align-items-center">
                  <b>Emails</b>
                </div>
              </p-divider>
              @if (lastPurchasedEmailBundles?.length === 0) {
                <p>
                No previously purchased email bundles to display. </p>
              }
              @if (lastPurchasedEmailBundles?.length !== 0) {
                <div>
                  <table class="table table-responsive-md">
                    <thead>
                      <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Date Bought</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody class=" text-nowrap">
                      @for (messageBundleAccount of lastPurchasedEmailBundles; track messageBundleAccount) {
                        <tr>
                          <td>{{ messageBundleAccount.description }}</td>
                          <td>
                            <div [hidden]="messageBundleAccount.dateTimePaid === null">
                              {{ messageBundleAccount.dateTimePaid | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                            </div>
                          </td>
                          <td>{{ messageBundleAccount.amount | toMajor | currency:'R ' }}</td>
                          <td [ngClass]="getAccountStatusUtil().getAccountTextColorClass(messageBundleAccount.accountState)">
                            {{ getDisplayStatus(messageBundleAccount.accountState) }}
                          </td>
                          <td>
                            <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(messageBundleAccount.accountState)">
                              <button (click)="cancelMessageBundle(messageBundleAccount)" class="orange-btn my-0">
                                Cancel
                              </button>
                            </div>
                          </td>
                          <td>
                            <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(messageBundleAccount.accountState)">
                              <button (click)="showQrCodeDialog(messageBundleAccount)" class="navy-btn my-0">
                                Pay
                              </button>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <p-dialog [(visible)]="showConfirmBuyDialog"
      [closable]="false"
      [modal]="true"
      [showHeader]="true"
      [style]="{width: '30em', marginBlock: '2em'}"
      header="Buy '{{ selectedMessageBundle?.name }}' message bundle?"
      styleClass="confirm-dialog custom-dialog">
      <div class="m-0 text-center">
        <p>
          Are you sure you want to buy <br>
          <b>{{ selectedMessageBundle?.quantity }} {{ selectedMessageBundle?.bundleType }}s</b> for
          <b>{{ selectedMessageBundle?.price | toMajor | currency:'R ' }}</b>? </p>
          <p>A request to pay transaction will be sent to:</p>
        </div>

        <div class="flex flex-column gap-2 px-2 text-center">
          <label>Email: <input #userEmail="ngModel"
            [(ngModel)]="messageBundleBuyRequest.userEmail"
            email
            pInputText
            required/> <br>
            @if (userEmail.errors?.['required']) {
              <div class="pl-1 pr-1" style="color:red">
                <small>An email is required.</small>
              </div>
            }
            @if (userEmail.errors?.['email']) {
              <div class="pl-1 pr-1" style="color:red">
                <small>Please enter a valid email.</small>
              </div>
            }
          </label>
        </div>
        <div class="row modal-buttons">
          <button (click)="closeBundleDialog()" class="btn-light btn-margin-top-bottom">
            Cancel <i class="fa fa-close"></i>
          </button>
          <button (click)="buyBundle()" [disabled]="!userEmail.valid" class="navy-btn btn-margin-top-bottom">
            Yes <i class="fa fa-check"></i>
          </button>
        </div>
      </p-dialog>

      <p-dialog [(visible)]="showMessageBundleQrCode"
        [dismissableMask]="false"
        [modal]="true"
        [style]="{width: '450px'}"
        header="Pay Message Bundle">
        <div class="card-body text-center">
          <div [hidden]="(selectedMessageBundleAccount?.description === null || selectedMessageBundleAccount?.description.length === 0)">
            <h2>{{ selectedMessageBundleAccount?.description }}</h2>
          </div>
          <h3>Recipient: {{ selectedMessageBundleAccount?.customer }}</h3>
          <h3>Amount: {{ selectedMessageBundleAccount?.amount | toMajor | currency:'R' }}</h3>
          @if (selectedMessageBundleAccount) {
            <div class="row">
              <div class="form-group col-md-12">
                <h6>Scan to Pay</h6>
                <qrcode [elementType]="'svg'"
                  [errorCorrectionLevel]="'M'"
                  [qrdata]="selectedMessageBundleAccount?.qrCode"
                [width]="256"></qrcode>
                <h6>Pay&#64; ({{ instanceName }}) #: {{ getPayAtNumber(selectedMessageBundleAccount?.qrCode) }}</h6>
              </div>
            </div>
          }
          <h3>Or</h3>
          <h3>Click
            <a (click)="onPayHereClick()" class="link-style">here</a>
            to pay
          </h3>
        </div>
      </p-dialog>
      <ngx-ui-loader></ngx-ui-loader>